import React, { FC } from 'react';
import { AllieText } from '../../../../components';
import { FlexContainer, StatsStyledContainer, StatsText } from '../StationListSummaryCard.styles';
import styled from 'styled-components';

interface StatsProps {
  data: {
    label: string;
    value: string;
  }[];
  isTablet?: boolean;
  layout?: 'card' | 'list';
}

const StyledStatsContainer = styled(StatsStyledContainer)`
  display: flex;
  flex-wrap: wrap;
`;

const StyledFlexContainer = styled(FlexContainer)`
  flex-basis: calc(33.33% - 8px);

  @media (max-width: 800px) {
    flex-basis: calc(33.33% - 8px);
  }
`;

export const Stats: FC<StatsProps> = ({ data, layout, isTablet = false }) => {
  const FinalFlexContainer = layout === 'list' ? StyledFlexContainer : FlexContainer;
  const FinalStatsContainer = layout === 'list' ? StyledStatsContainer : StatsStyledContainer;

  return (
    <FinalStatsContainer flexDirection={isTablet ? 'row' : 'column'} isTablet={isTablet}>
      {data.map(({ label, value }, index) => (
        <FinalFlexContainer
          justifyContent="space-between"
          key={`${label}-${value}-${index}`}
          style={{
            padding: isTablet ? '0 1%' : '6px 0',
            borderBottom: isTablet ? 'none' : '1px solid var(--allie-color-neutral-20)',
            maxWidth: isTablet ? 'unset' : '100%',
            width: '100%',
            flexGrow: 1,
            flexShrink: 1,
            gap: 4,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <StatsText type="body3" collapsible={false}>
            {label}
          </StatsText>
          <StatsText type="button-medium" collapsible>
            {value}
          </StatsText>
        </FinalFlexContainer>
      ))}
    </FinalStatsContainer>
  );
};
